/**
 * The one office summerlinasia.com lists. No email address is published on the
 * current site, so none is invented here — the contact page offers the form
 * and the phone.
 */
export const CONTACT = {
  company: 'Summerlin Co., Ltd.',
  addressLines: [
    '1 Empire Tower, 47th Floor',
    'South Sathorn Road, Yannawa, Sathorn',
    'Bangkok 10120, Thailand',
  ],
  phoneDisplay: '+66 2 119 8474',
  phoneHref: 'tel:+6621198474',
  mapsUrl:
    'https://www.google.com/maps/search/?api=1&query=Empire+Tower+1+South+Sathorn+Road+Bangkok+10120',
} as const;

/**
 * Where the contact form posts, as JSON `{ firstName, lastName, email, message }`.
 * The original Weebly form posted to Weebly's own backend, which does not come
 * with the site. Point this at whatever receives it (a Function, Formspree, a
 * LaundryAPI endpoint) and add that origin to the CSP `connect-src` in
 * index.html. While unset, the form explains how to reach the office instead.
 */
export const CONTACT_FORM_ENDPOINT: string | undefined =
  import.meta.env.VITE_CONTACT_FORM_ENDPOINT;
